import Navbar from "../Navbar";
import { UrlApi } from "../../services/apirest";
import { useEffect, useState } from "react";

import {
  Typography,
  Box,
  Button,
  TextField,
  Paper,
  Grid,
  Autocomplete,
} from "@mui/material";
import moment from "moment";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { verEnviarPDF } from "../../services/services";
import PrintIcon from '@mui/icons-material/Print';
import { logEventos } from "../../services/services";
function Buscadorfacturas() {

  const [datosconsulta, setDatosconsulta] = useState({
    pto_venta: "",
    nro_comprobante: "",
  });
//console.log("datosconsulta",datosconsulta)
 const [mostrarfactura, setMostrarfactura] = useState(false);
//console.log("mostrarfactura",mostrarfactura)
  const rrhhAdmin = localStorage.getItem("adminrrhh");
  const user = localStorage.getItem("user");

  const [datos, setDatos] = useState();
//console.log("datos",datos)
const [filtrarPorPuntoVenta, setFiltrarPorPuntoVenta] = useState(false);


const [openSnackbar, setOpenSnackbar] = useState(false);
const [snackbarMessage, setSnackbarMessage] = useState('');
const [snackbarSeverity, setSnackbarSeverity] = useState('success'); // 'success' | 'error'
  const [disBtn, setDisBtn] = useState(false);
  function almacenar(e) {
    setDatosconsulta({
      ...datosconsulta,
      [e.target.name]: e.target.value,
    });
  }

  const handleConsultar = async () => {
  const { nro_comprobante, pto_venta } = datosconsulta;

  // Validar punto de venta
  if (!pto_venta) {
    setSnackbarSeverity('error');
    setSnackbarMessage('Debe ingresar un punto de venta');
    setOpenSnackbar(true);
    return;
  }

  // Si no se filtra solo por punto de venta, también validar nro_comprobante
  if (!filtrarPorPuntoVenta && !nro_comprobante) {
    setSnackbarSeverity('error');
    setSnackbarMessage('Debe ingresar un número de comprobante');
    setOpenSnackbar(true);
    return;
  }

  try {
    const endpoint = filtrarPorPuntoVenta
      ? `${UrlApi}/envasado_pedidos/buscadorverfacturaxptoventa/${pto_venta}`
      : `${UrlApi}/envasado_pedidos/buscadorverfactura/${pto_venta}/${nro_comprobante}`;

    const response = await fetch(endpoint);

    if (!response.ok) throw new Error("Error al obtener factura");

    const data = await response.json();

    if (data.length === 0) {
      setDatos([]);
      setSnackbarSeverity('error');
      setSnackbarMessage('No se encontraron resultados');
      setOpenSnackbar(true);
      setMostrarfactura(false);
      return;
    }

    setDatos(data);
    setMostrarfactura(true);
  } catch (error) {
    setDatos([]);
    console.error("Error en la consulta:", error);
    setSnackbarSeverity('error');
    setSnackbarMessage('Error en la consulta de factura');
    setOpenSnackbar(true);
  }
};

useEffect(() => {
  logEventos(
  "acceso al menú Buscador de Comprobantes", 
  "Granel", 
  "Buscar Comprobantes", 
  localStorage.getItem("user"));
}, []);


   

 return (
    <>
      <Navbar />
      {/* contenedor principal  */}
      <Grid container sx={{ minHeight: '100vh' }} >
  {/* Buscar Factura - Columna izquierda */}
  <Grid item xs={3}
   //sx={{ backgroundColor: '#fce4ec' }} 
      sx={{ backgroundColor: '#e3f2fd' }} 
   >

   

    <Box
      component={Paper}
      elevation={4}
      sx={{
        p: 3,
        bgcolor: "#DAF7A6",
        borderRadius: 2,
        ml:1,
        mt:3
      }}
    >


    <Box
  sx={{
    display: 'flex',
    justifyContent: 'space-between', // separa texto y botón
    alignItems: 'center', // alinea verticalmente
    mb: 2,
  }}
>
  <Typography variant="h6" fontWeight="bold" gutterBottom>
    Buscar Comprobante
  </Typography>

  <Button
    variant="outlined"
    onClick={() => setFiltrarPorPuntoVenta((prev) => !prev)}
  >
    {filtrarPorPuntoVenta
      ? "Filtrar por N° y Punto de Venta"
      : "Filtrar por Punto de Venta"}
  </Button>
</Box>


      <TextField
        required
        fullWidth
        label="Punto De venta"
        size="small"
        value={datosconsulta.pto_venta}
        // error={
        //   datosconsulta.pto_venta &&
        //   !isValidFactura(datosconsulta.pto_venta)
        // }
        // helperText={
        //   datosconsulta.pto_venta &&
        //   !isValidFactura(datosconsulta.pto_venta) //
        //     ? "punto de venta  no válido"
        //     : ""
        // }
        sx={{mb:1}}
        onChange={(e) => {
          const valor = e.target.value;
          const regex = /^[0-9]*$/;
          if (regex.test(valor)) {
            almacenar({ target: { name: "pto_venta", value: valor } });
          }
        }}
      />


      <TextField
         required={!filtrarPorPuntoVenta}
          disabled={filtrarPorPuntoVenta}
        fullWidth
        label="Número de Comprobante"
        size="small"
        value={datosconsulta.nro_comprobante}
          sx={{mt:1}}
        // error={
        //   datosconsulta.nro_comprobante &&
        //   !isValidFactura(datosconsulta.nro_comprobante)
        // }
        // helperText={
        //   datosconsulta.nro_comprobante &&
        //   !isValidFactura(datosconsulta.nro_comprobante) //
        //     ? "Número no válido"
        //     : ""
        // }
        onChange={(e) => {
          const valor = e.target.value;
          const regex = /^[0-9]*$/;
          if (regex.test(valor)) {
            almacenar({ target: { name: "nro_comprobante", value: valor } });
          }
        }}
      />

      <Button
        fullWidth
        variant="contained"
        sx={{ mt: 2 }}
        onClick={handleConsultar}
        disabled={
    !datosconsulta.pto_venta || // siempre requerido
    (!filtrarPorPuntoVenta && !datosconsulta.nro_comprobante) // solo se requiere nro_comprobante si no estás en modo por punto de venta
  }
      >
        CONSULTAR
      </Button>
    </Box>
    
  </Grid>


 
{/* contenedor secundario , sx para ver donde empieza o termina el item */}

      <Grid item xs={9} 
      sx={{ backgroundColor: '#e3f2fd' }} 
      
      >

        {mostrarfactura && datos.length > 0 && (
        datos.map((factura, index) => (
       <Grid item xs={12} md={11} key={index} >
      <Box
        sx={{
          p: 3,
          border: 10,
          borderColor: "#006064",
          borderRadius: 2,
          mb: 2, // espacio entre facturas si hay varias
          ml:10,
          mt:2
        }}
      >
      
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            Información del Comprobante
          </Typography>

        <Button
  variant="contained"
  startIcon={<PrintIcon />} // acá se agrega el ícono al principio //
  sx={{ bgcolor: "#1976d2", color: "white" }}
  onClick={() => {
    if (factura.id_factura) {
      verEnviarPDF(factura.id_factura, 0);
    } else {
      console.warn("ID de factura no disponible");
    }
  }}
>
  IMPRIMIR Comprobante
</Button>

        </Box>

      
        <Grid container spacing={1}>
          <Grid item xs={12} sm={6}>
            <strong>{factura.texto_comprobante}  - {factura.letra} N°:</strong>{" "}
              
            {String(factura.pto_venta).padStart(4, "0")}-{String(factura.nro_comprobante).padStart(8, "0")}
          </Grid>
          <Grid item xs={12} sm={6}>
            <strong>Punto de Venta:</strong> {factura.pto_venta}
          </Grid>
          <Grid item xs={12} sm={6}>
            <strong>Cliente:</strong> {factura.razon_social?.trim()}
          </Grid>
          <Grid item xs={12} sm={6}>
            <strong>CUIT:</strong> {factura.cuit_empresa_emisora}
          </Grid>
          <Grid item xs={12} sm={6}>
            <strong>Condición IVA:</strong> {factura.condicion_iva}
          </Grid>
          <Grid item xs={12} sm={6}>
            <strong>Condición de Pago:</strong> {factura.condicion_pago}
          </Grid>
          <Grid item xs={12} sm={6}>
            <strong>Fecha de Emisión:</strong>{" "}
            {moment(factura.fecha_emision).format("DD-MM-YYYY")}
          </Grid>
          <Grid item xs={12} sm={6}>
            <strong>Fecha Vto. CAE:</strong>{" "}
            {moment(factura.vencimiento_cae, "YYYYMMDD").format("DD-MM-YYYY")}
          </Grid>
          <Grid item xs={12} sm={6}>
            <strong>Importe Neto:</strong> ${Number(factura.importe_neto).toFixed(2)}
          </Grid>
          <Grid item xs={12} sm={6}>
            <strong>IVA:</strong> ${Number(factura.importe_iva).toFixed(2)}
          </Grid>
          <Grid item xs={12} sm={6}>
            <strong>Importe Total:</strong> ${Number(factura.importe_total).toFixed(2)}
          </Grid>
          <Grid item xs={12} sm={6}>
            <strong>Moneda:</strong> {factura.moneda}
          </Grid>
          <Grid item xs={12} sm={6}>
            <strong>CAE:</strong> {factura.cae}
          </Grid>
          <Grid item xs={12} sm={6}>
            <strong>N° Sisven:</strong> {factura.nro_sisven}
          </Grid>
          <Grid item xs={12} sm={6}>
            <strong>Domicilio Cliente:</strong> {factura.domicilio}
          </Grid>
          <Grid item xs={12} sm={6}>
            <strong>Código Comprobante AFIP:</strong> {factura.codigo_comprobante_afip}
          </Grid>
          <Grid item xs={12} sm={6}>
            <strong>Provincia:</strong> {factura.provincia} —{" "}
            <strong>Localidad:</strong> {factura.localidad}
          </Grid>
          <Grid item xs={12} sm={6}>
            <strong>Tipo:</strong> {factura.texto_comprobante} —{" "}
            <strong>Letra:</strong> {factura.letra}
          </Grid>
       
        </Grid>
      </Box>
        <br></br>
    </Grid>
    
  ))
)} 
      </Grid>

</Grid>




 <Snackbar
  open={openSnackbar}
  autoHideDuration={2000}
  onClose={() => setOpenSnackbar(false)}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
  <MuiAlert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
    {snackbarMessage}
  </MuiAlert>
</Snackbar>

    </>
  );
}

export default Buscadorfacturas